import { PayoutRequisitesPage } from 'features/payout-requisites';

export const OperatorPayoutRequisitesPage: React.FC = () => (
  <PayoutRequisitesPage />
);
